import React from 'react'
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BassURl from '../Api/Api';
import { addToCartAction } from '../Redux/Action/CartAction';
import { addToCartReducer } from '../Redux/Reducer/CartReducer';
import MobileProductQty from './MobileProductQty';
import './MobileService.css'
import { MobilePopupForm } from '../Model/MobilePopupForm';
import { NavLink } from 'react-router-dom';


function MobileApplianceDetailChild({ data }) {
    const dispatch = useDispatch();
    function addtocart() {
        dispatch(addToCartAction(data, 1));
    }
    const [activeId, setActiveId] = useState();
    return (
        <>
            <div className="product-list media">
                <NavLink to="">
                    <img loading="lazy" src={`${BassURl}${data?.product_image}`} style={{
                                                                    width: "95%"
                                                                }} alt="offer" />
                </NavLink>
                <div className="media-body">
                    <NavLink className="font-sms">
                        {data?.product_title}
                    </NavLink>
                    {/* <span className="content-color font-xs">{data?.description}</span> */}
                    <span className="title-color font-sms">
                        ₹ {data?.product_price}
                        <span className="badges-round bg-theme-theme font-xs">50% off</span>
                    </span>

                    {/* <div className="plus-minus" onClick={addtocart}>
                        {
                            activeId === data.id ? (<>
                                <MobileProductQty item={data} />

                            </>) : (<div>

                                <span className='added' onClick={() => { setActiveId(data.id) }}>ADD +</span>

                            </div>)

                        }
                    </div> */}
                  <MobilePopupForm/>
                </div>
            </div>




        </>
    )
}

export default MobileApplianceDetailChild